var ENABLE_LOGS = ( typeof development !== 'undefined') ? true : false;
 
var _log = function(print_msg, optional_param, error){
    ENABLE_LOGS && (!error ? console.log(print_msg, optional_param !== undefined ? optional_param : ' ') : console.error(print_msg, optional_param || ""));
}

var cookieConsent   = initCookieConsent();
var logo            = 'Cookies';
var cookie          = '';
var cookieConsentStarted = false;
function runCookieConsent() {
if (cookieConsentStarted) {
    return;
}
cookieConsentStarted = true;
cookieConsent.run({
    current_lang : document.documentElement.lang,
    autoclear_cookies : true,
    theme_css: '',
    cookie_name: 'cc_cookie_'+document.domain,
    cookie_expiration : 365,
    page_scripts: true,
    auto_language: document,
    cookie_domain: location.hostname,
    autorun: true,
    delay: 0,
    force_consent: false,
    hide_from_bots: false,
    remove_cookie_tables: false,
    cookie_path: "/",
    cookie_same_site: "Lax",
    use_rfc_cookie: false,
    revision: 1809420234,
    gui_options: {
        consent_modal: {
            layout: 'box',
            position: 'bottom left',
            transition: 'slide'
        },
        settings_modal: {
            layout: 'box',
            // position: 'left',
            transition: 'slide'
        }
    },
    onFirstAction: function (user_preferences) {
        if (typeof gtag === 'function') {
            _log('Cookie Consent onFirstAction');
            _log('User accept type:', user_preferences.accept_type);
            _log('User accepted these categories', user_preferences.accepted_categories)
            _log('User reject these categories:', user_preferences.rejected_categories);
            if (user_preferences.accepted_categories.indexOf('analytics') > -1) {  
                _log('Cookie Consent onFirstAction - analytics_storage: granted');
                gtag('consent', 'update', { 
                    'analytics_storage': 'granted'
                }); 
            }
            if (user_preferences.accepted_categories.indexOf('marketing') > -1) {  
                _log('Cookie Consent onFirstAction - ad_storage: granted');
                _log('Cookie Consent onFirstAction - ad_user_data: granted');
                _log('Cookie Consent onFirstAction - ad_personalization: granted');
                gtag('consent', 'update', {
                    'ad_storage': 'granted',  
                    'ad_user_data': 'granted',  
                    'ad_personalization': 'granted', 
                });  
            }
            if (user_preferences.rejected_categories.indexOf('analytics') > -1) { 
                _log('Cookie Consent onFirstAction - analytics_storage: denied');
                gtag('consent', 'update', { 
                    'analytics_storage': 'denied'
                });  
            }
            if (user_preferences.rejected_categories.indexOf('marketing') > -1) {  
                _log('Cookie Consent onFirstAction - ad_storage: denied');
                _log('Cookie Consent onFirstAction - ad_user_data: denied');
                _log('Cookie Consent onFirstAction - ad_personalization: denied');
                gtag('consent', 'update', {
                    'ad_storage': 'denied', 
                    'ad_user_data': 'denied',  
                    'ad_personalization': 'denied', 
                });  
            }
        }
    }, 
    onAccept: function () { 
        if (typeof gtag === 'function') {
            // _log('Cookie Consent onAccept - analytics_storage: granted');  
            // _log('Cookie Consent onAccept - ad_storage: granted');  
            // _log('Cookie Consent onFirstAction - ad_user_data: granted');
            // _log('Cookie Consent onFirstAction - ad_personalization: granted');
            // gtag('consent', 'update', { 
            //    'analytics_storage': 'granted',
            //    'ad_storage': 'granted', 
            //    'ad_user_data': 'granted',  
            //    'ad_personalization': 'granted', 
            // });  
        }
    }, 
    onReject: function (cookie) {
        if (typeof gtag === 'function') {
            // _log('Cookie Consent onReject - ad_storage: denied');
            // _log('Cookie Consent onReject - analytics_storage: denied');
            // _log('Cookie Consent onFirstAction - ad_user_data: denied');
            // _log('Cookie Consent onFirstAction - ad_personalization: denied');
            // gtag('consent', 'update', {
            //    'ad_storage': 'denied',
            //    'analytics_storage': 'denied'
            //    'ad_user_data': 'denied',  
            //    'ad_personalization': 'denied', 
            // }); 
        }
    },
    onChange: function (cookie, changed_preferences) {
        if (typeof gtag === 'function') {
            _log('Cookie Consent onChange');
            if (changed_preferences.indexOf('analytics') > -1) { 
                if (!cc.allowedCategory('analytics')) {  
                    _log('Cookie Consent onChange - analytics_storage: denied');
                    gtag('consent', 'update', { 
                        'analytics_storage': 'denied'
                    }); 
                }else{  
                    _log('Cookie Consent onChange - analytics_storage: granted');
                    gtag('consent', 'update', { 
                        'analytics_storage': 'granted'
                    }); 
                    if (typeof seznam === "function") {
                        seznam();
                        _log('Cookie Consent onChange - seznam: granted');
                    }
                    if (typeof smartsupp === "function") {
                        smartsupp();
                        _log('Cookie Consent onChange - smartsupp: granted');
                    }
                }
            } 
            if (changed_preferences.indexOf('marketing') > -1) { 
                if (!cc.allowedCategory('marketing')) {  
                    _log('Cookie Consent onChange - ad_storage: denied');
                    _log('Cookie Consent onFirstAction - ad_user_data: denied');
                    _log('Cookie Consent onFirstAction - ad_personalization: denied');
                    gtag('consent', 'update', {
                        'ad_storage': 'denied', 
                        'ad_user_data': 'denied',  
                        'ad_personalization': 'denied', 
                    }); 
                }else{  
                    _log('Cookie Consent onChange - ad_storage: granted');
                    _log('Cookie Consent onFirstAction - ad_user_data: granted');
                    _log('Cookie Consent onFirstAction - ad_personalization: granted');
                    gtag('consent', 'update', {
                        'ad_storage': 'granted', 
                        'ad_user_data': 'granted',  
                        'ad_personalization': 'granted', 
                    }); 
                    if (typeof facebook === "function") {
                        facebook();
                        _log('Cookie Consent onChange - facebook: granted');
                    } 
                }
            } 
        }  
    },
    languages: {
        'sk': {
            consent_modal: {
                title: cookie + ' Používame cookies!',
                description: 'Dobrý deň, táto webová stránka používa nevyhnutné súbory cookie na zabezpečenie správneho fungovania, personalizáciu reklám a analýzu návštevnosti. <button type="button" data-cc="c-settings" class="cc-link">Zmeniť nastavenia</button>',
                primary_btn: {
                    text: 'Prijať všetko',
                    role: 'accept_all'
                },
                secondary_btn: {
                    text: 'Odmietnuť všetko',
                    role: 'accept_necessary'
                }
            },
            settings_modal: {
                title: logo,
                save_settings_btn: 'Uložiť nastavenia',
                accept_all_btn: 'Prijať všetko',
                reject_all_btn: 'Odmietnuť všetko',
                close_btn_label: 'Zavrieť',
                cookie_table_headers: [
                    {col1: 'Názov'},
                    {col2: 'Doména'},
                    {col3: 'Expirácia'},
                    {col4: 'Popis'}
                ],
                blocks: [
                    {
                        title: '',
                        description: 'Cookies používam na zabezpečenie základných funkcií webovej stránky a na personalizáciu reklám a analýzu návštevnosti. Pre každú kategóriu si môžete vybrať, či sa chcete kedykoľvek prihlásiť/odhlásiť. Ďalšie podrobnosti týkajúce sa súborov cookie a iných citlivých údajov nájdete v úplnom znení v <a href="'+privacy_url+'" class="cc-link">ochrane osobných údajov</a>.'
                    }, 
                    {
                        title: 'Nevyhnutne potrebné cookies',
                        description: 'Tieto cookies sú nevyhnutné pre správne fungovanie našej webovej stránky. Bez týchto cookies by webová stránka nefungovala správne.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true
                        },
                        cookie_table: [
	                        {
                                col1: '_grecaptcha',
                                col2: 'google.com',
                                col3: 'Bez expirácie',
                                col4: 'Tento súbor cookie sa používa na rozlíšenie medzi ľuďmi a robotmi. Je to výhodné pre webovú stránku, aby mohla vytvárať platné správy o používaní ich webovej stránky.',
                                is_regex: false
                            },
	                        {
                                col1: 'cialsession',
                                col2: 'horskamania.sk',
                                col3: '1 mesiac',
                                col4: 'Nevyhnutne potrebné cookies',
                                is_regex: false
                            }
                        ] 
                            
                    }, 
                    {
                        title: 'Súbory cookie na meranie výkonu a návštevnosti',
                        description: 'Tieto súbory cookie umožňujú webovej stránke zapamätať si úkony, ktoré ste urobili v minulosti.',
                        toggle: {
                            value: 'analytics',
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [ 
	                        {
                                col1: '_hjAbsoluteSessionInProgress',
                                col2: 'hotjar.com',
                                col3: '1 deň',
                                col4: "Tento súbor cookie sa používa na zisťovanie toho, koľkokrát webovú stránku navštívili rôzni návštevníci – robí sa to tak, že sa návštevníkovi pridelí ID, takže sa návštevník nezaregistruje dvakrát.",
                                is_regex: false
                            }, 
	                        {
                                col1: '_hjFirstSeen',
                                col2: 'hotjar.com',
                                col3: '1 deň',
                                col4: "Tento súbor cookie sa používa na určenie, či návštevník už navštívil webovú stránku predtým, alebo či ide o nového návštevníka webovej stránky.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjIncludedInSessionSample',
                                col2: 'hotjar.com',
                                col3: '1 deň',
                                col4: "Registruje údaje o správaní návštevníkov webu. Toto sa používa na internú analýzu a optimalizáciu webových stránok.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjIncludedInPageviewSample',
                                col2: 'hotjar.com',
                                col3: '1 deň',
                                col4: "Používa sa na zistenie toho, či navigácia používateľa a interakcie sú zahrnuté v údajoch webovej stránky a v analýze.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjRecordingLastActivity',
                                col2: 'hotjar.com',
                                col3: 'Počas návštevy',
                                col4: 'Nastaví jedinečné ID pre reláciu. To umožňuje webovej stránke získavať údaje o správaní návštevníkov na štatistické účely.',
                                is_regex: false
                            }, 
	                        {
                                col1: '_hjSession_#',
                                col2: 'hotjar.com',
                                col3: '1 deň', 
                                col4: "Zhromažďuje štatistiky o návštevách návštevníka na webe, ako napríklad počet návštev, priemerný čas strávený na webe a prečítané stránky.",
                                is_regex: true
                            },  
	                        {
                                col1: '_hjSessionUser_#',
                                col2: 'hotjar.com',
                                col3: '1 rok',
                                col4: "Zhromažďuje štatistiky o návštevách návštevníka na webe, ako napríklad počet návštev, priemerný čas strávený na webe a prečítané stránky.",
                                is_regex: true
                            }, 
	                        {
                                col1: 'hjViewportId',
                                col2: 'hotjar.com',
                                col3: 'Počas návštevy',
                                col4: "Nastaví jedinečné ID pre reláciu. To umožňuje webovej stránke získavať údaje o správaní návštevníkov na štatistické účely.",
                                is_regex: false
                            }, 
                            {
                                col1: '_ga',
                                col2: 'google.com',
                                col3: '2 roky',
                                col4: "Registruje jedinečné ID, ktoré sa používa na generovanie štatistických údajov o tom, ako návštevník používa webovú stránku.",
                                is_regex: true
                            },
                            {
                                col1: '_gat',
                                col2: 'google.com',
                                col3: '1 deň',
                                col4: "Používa ho Google Analytics na zníženie počtu žiadostí.",
                                is_regex: false
                            },
                            {
                                col1: '_gid',
                                col2: 'google.com',
                                col3: '1 deň',
                                col4: "Registruje jedinečné ID, ktoré sa používa na generovanie štatistických údajov o tom, ako návštevník používa webovú stránku.",
                                is_regex: false
                            },
	                        {
                                col1: '_gat_gtag',
                                col2: 'google.com',
                                col3: '1 minúta',
                                col4: 'Nastavil Google na rozlíšenie používateľov.',
                                is_regex: false
                            },
                        ]
                    }, 
                    {
                        title: 'Cookies pre reklamu a zacielenie',
                        description: 'Tieto cookies zhromažďujú informácie o tom, ako používate webovú stránku, ktoré stránky ste navštívili a na ktoré odkazy ste klikli. Všetky údaje sú anonymizované a nie je možné ich použiť na vašu identifikáciu.',
                        toggle: {
                            value: 'marketing',
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [
	                        {
                                col1: '_gcl_au',
                                col2: 'google.com',
                                col3: '3 mesiace',
                                col4: "Používa ho Google AdSense na experimentovanie s efektívnosťou reklamy na webových stránkach využívajúcich ich služby.",
                                is_regex: false
                            },
                            {
                                col1: '_fbp',
                                col2: 'facebook.com',
                                col3: '3 mesiace',
                                col4: "Používa ho Facebook na poskytovanie série reklamných produktov, ako sú ponuky v reálnom čase od inzerentov tretích strán.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjRecordingEnabled',
                                col2: 'hotjar.com',
                                col3: 'Počas návštevy',
                                col4: "Tento súbor cookie sa používa na identifikáciu návštevníka a na optimalizáciu relevancie reklamy zhromažďovaním údajov o návštevníkoch z viacerých webových stránok – túto výmenu údajov o návštevníkoch zvyčajne poskytuje dátové centrum tretej strany alebo výmena reklám.",
                                is_regex: false
                            },  
	                        {
                                col1: 'ads/ga-audiences',
                                col2: 'google.com',
                                col3: 'Počas návštevy',
                                col4: "Používa ho Google AdWords na opätovné prilákanie návštevníkov, ktorí sa pravdepodobne zmenia na zákazníkov na základe správania sa návštevníka na webových stránkach.",
                                is_regex: false
                            }, 
	                        {
                                col1: 'IDE',
                                col2: 'doubleclick.net',
                                col3: '1 rok',
                                col4: "Používa ho Google DoubleClick na registráciu a nahlásenie akcií používateľa na webovej stránke po zobrazení alebo kliknutí na reklamy inzerenta s cieľom merania účinnosti reklamy a prezentovať používateľovi cielené reklamy.",
                                is_regex: false
                            },
	                        {
                                col1: 'pagead/1p-user-list/#',
                                col2: 'google.com',
                                col3: 'Počas návštevy',
                                col4: "Sleduje, či používateľ prejavuje záujem o konkrétne produkty alebo udalosti na viacerých webových stránkach, a zisťuje, ako sa používateľ pohybuje medzi stránkami. Používa sa na meranie reklamného úsilia a uľahčuje platbu poplatkov za sprostredkovanie medzi webovými stránkami.",
                                is_regex: false
                            }, 
                            {
                                col1: 'tr',
                                col2: 'facebook.com',
                                col3: 'Počas návštevy',
                                col4: "Používa ho Facebook na poskytovanie série reklamných produktov, ako sú ponuky v reálnom čase od inzerentov tretích strán.",
                                is_regex: false
                            },
                        ]     
                    }, 
                    {
                        title: 'Viac informácií',
                        description: 'V prípade akýchkoľvek otázok v súvislosti s našimi zásadami týkajúcimi sa súborov cookie a vašim výberom, prosím <a class="cc-link" href="'+contact_url+'">kontaktujte nás</a>.',
                    }
                ]
            }
        },
        'cz': {
            consent_modal: {
                title: cookie + ' Používáme cookies!',
                description: 'Dobrý den, tato webová stránka používá nezbytné soubory cookie k zajištění správného fungování, personalizaci reklam a analýze návštěvnosti. <button type="button" data-cc="c-settings" class="cc-link">Změnit nastavení</button>',
                primary_btn: {
                    text: 'Přijmout vše',
                    role: 'accept_all'
                },
                secondary_btn: {
                    text: 'Odmítnout všechno',
                    role: 'accept_necessary'
                }
            },
            settings_modal: {
                title: logo,
                save_settings_btn: 'Uložit nastavení',
                accept_all_btn: 'Přijmout vše',
                reject_all_btn: 'Odmítnout všechno',
                close_btn_label: 'Zavřít',
                cookie_table_headers: [
                    {col1: 'Název'},
                    {col2: 'Doména'},
                    {col3: 'Expirace'},
                    {col4: 'Popis'}
                ],
                blocks: [
                    {
                        title: '',
                        description: 'Cookies používám k zajištění základních funkcí webové stránky ak personalizaci reklam a analýze návštěvnosti. Pro každou kategorii si můžete vybrat, zda se chcete kdykoli přihlásit/odhlásit. Další podrobnosti týkající se souborů cookie a jiných citlivých údajů naleznete v úplném znění v <a href="'+privacy_url+'" class="cc-link">ochraně osobních údajů</a>.'
                    }, 
                    {
                        title: 'Nezbytně nutné cookies',
                        description: 'Tyto cookies jsou nezbytné pro správné fungování naší webové stránky. Bez těchto cookies by webová stránka nefungovala správně.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true
                        },
                        cookie_table: [
	                        {
                                col1: '_grecaptcha',
                                col2: 'google.com',
                                col3: 'Bez expirace',
                                col4: 'Tento soubor cookie se používá k rozlišení mezi lidmi a roboty. Je to výhodné pro webovou stránku, aby mohla vytvářet platné zprávy o používání jejich webové stránky.',
                                is_regex: false
                            },
	                        {
                                col1: 'cialsession',
                                col2: 'horskamania.sk',
                                col3: '1 měsíc',
                                col4: 'Nezbytně nutné cookies',
                                is_regex: false
                            }
                        ] 
                            
                    }, 
                    {
                        title: 'Soubory cookie pro měření výkonu a návštěvnosti',
                        description: 'Tyto soubory cookie umožňují webové stránce zapamatovat si úkony, které jste provedli v minulosti.',
                        toggle: {
                            value: 'analytics',
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [ 
	                        {
                                col1: '_hjAbsoluteSessionInProgress',
                                col2: 'hotjar.com',
                                col3: '1 den',
                                col4: "Tento soubor cookie se používá ke zjišťování toho, kolikrát webovou stránku navštívili různí návštěvníci – dělá se to tak, že se návštěvníkovi přidělí ID, takže se návštěvník nezaregistruje dvakrát.",
                                is_regex: false
                            }, 
	                        {
                                col1: '_hjFirstSeen',
                                col2: 'hotjar.com',
                                col3: '1 den',
                                col4: "Tento soubor cookie se používá k určení, zda návštěvník již navštívil webovou stránku předtím, nebo zda se jedná o nového návštěvníka webové stránky.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjIncludedInSessionSample',
                                col2: 'hotjar.com',
                                col3: '1 den',
                                col4: "Registruje údaje o chování návštěvníků webu. Toto se používá pro interní analýzu a optimalizaci webových stránek.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjIncludedInPageviewSample',
                                col2: 'hotjar.com',
                                col3: '1 den',
                                col4: "Používá se ke zjištění, zda navigace uživatele a interakce jsou zahrnuty v údajích webové stránky a v analýze.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjRecordingLastActivity',
                                col2: 'hotjar.com', 
                                col3: 'Během návštěvy',
                                col4: 'Nastaví jedinečné ID pro relaci. To umožňuje webové stránce získávat údaje o chování návštěvníků pro statistické účely.',
                                is_regex: false
                            }, 
	                        {
                                col1: '_hjSession_#',
                                col2: 'hotjar.com',
                                col3: '1 den', 
                                col4: "Shromažďuje statistiky o návštěvách návštěvníka na webu, jako například počet návštěv, průměrný čas strávený na webu a přečtené stránky.",
                                is_regex: true
                            },  
	                        {
                                col1: '_hjSessionUser_#',
                                col2: 'hotjar.com',
                                col3: '1 rok',
                                col4: "Shromažďuje statistiky o návštěvách návštěvníka na webu, jako například počet návštěv, průměrný čas strávený na webu a přečtené stránky.",
                                is_regex: true
                            }, 
	                        {
                                col1: 'hjViewportId',
                                col2: 'hotjar.com',
                                col3: 'Během návštěvy',
                                col4: "Nastaví jedinečné ID pro relaci. To umožňuje webové stránce získávat údaje o chování návštěvníků pro statistické účely.",
                                is_regex: false
                            }, 
                            {
                                col1: '_ga',
                                col2: 'google.com',
                                col3: '2 roky',
                                col4: "Registruje jedinečné ID, které se používá ke generování statistických údajů o tom, jak návštěvník používá webovou stránku.",
                                is_regex: true
                            },
                            {
                                col1: '_gat',
                                col2: 'google.com',
                                col3: '1 den',
                                col4: "Používá jej Google Analytics ke snížení počtu žádostí.",
                                is_regex: false
                            },
                            {
                                col1: '_gid',
                                col2: 'google.com',
                                col3: '1 den',
                                col4: "Registruje jedinečné ID, které se používá ke generování statistických údajů o tom, jak návštěvník používá webovou stránku.",
                                is_regex: false
                            },
	                        {
                                col1: '_gat_gtag',
                                col2: 'google.com',
                                col3: '1 minuta',
                                col4: 'Nastavil Google pro rozlišení uživatelů.',
                                is_regex: false
                            },
                        ]
                    }, 
                    {
                        title: 'Cookies pro reklamu a zacílení',
                        description: 'Tyto cookies shromažďují informace o tom, jak používáte webovou stránku, které stránky jste navštívili a na které odkazy jste klikli. Všechny údaje jsou anonymizovány a nelze je použít k vaší identifikaci.',
                        toggle: {
                            value: 'marketing',
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [
	                        {
                                col1: '_gcl_au',
                                col2: 'google.com',
                                col3: '3 měsíce',
                                col4: "Používá jej Google AdSense k experimentování s efektivností reklamy na webových stránkách využívajících jejich služby.",
                                is_regex: false
                            },
                            {
                                col1: '_fbp',
                                col2: 'facebook.com',
                                col3: '3 měsíce',
                                col4: "Používá jej Facebook k poskytování série reklamních produktů, jako jsou nabídky v reálném čase od inzerentů třetích stran.",
                                is_regex: false
                            },
	                        {
                                col1: '_hjRecordingEnabled',
                                col2: 'hotjar.com',
                                col3: 'Během návštěvy',
                                col4: "Tento soubor cookie se používá k identifikaci návštěvníka ak optimalizaci relevance reklamy shromažďováním údajů o návštěvnících z více webových stránek – tuto výměnu údajů o návštěvnících obvykle poskytuje datové centrum třetí strany nebo výměna reklam.",
                                is_regex: false
                            },  
	                        {
                                col1: 'ads/ga-audiences',
                                col2: 'google.com',
                                col3: 'Během návštěvy',
                                col4: "Používá jej Google DoubleClick k registraci a nahlášení akcí uživatele na webové stránce po zobrazení nebo kliknutí na reklamy inzerenta za účelem měření účinnosti reklamy a prezentovat uživateli cílené reklamy.",
                                is_regex: false
                            }, 
	                        {
                                col1: 'IDE',
                                col2: 'doubleclick.net',
                                col3: '1 rok',
                                col4: "Používá jej Google DoubleClick k registraci a nahlášení akcí uživatele na webové stránce po zobrazení nebo kliknutí na reklamy inzerenta za účelem měření účinnosti reklamy a prezentovat uživateli cílené reklamy.",
                                is_regex: false
                            },
	                        {
                                col1: 'pagead/1p-user-list/#',
                                col2: 'google.com',
                                col3: 'Během návštěvy',
                                col4: "Sleduje, zda uživatel projevuje zájem o konkrétní produkty nebo události na více webových stránkách, a zjišťuje, jak se uživatel pohybuje mezi stránkami. Používá se k měření reklamního úsilí a usnadňuje platbu poplatků za zprostředkování mezi webovými stránkami.",
                                is_regex: false
                            }, 
                            {
                                col1: 'tr',
                                col2: 'facebook.com',
                                col3: 'Během návštěvy',
                                col4: "Používá jej Facebook k poskytování série reklamních produktů, jako jsou nabídky v reálném čase od inzerentů třetích stran.",
                                is_regex: false
                            },
                        ]     
                    }, 
                    {
                        title: 'Více informací',
                        description: 'V případě jakýchkoliv otázek v souvislosti s našimi zásadami týkajícími se souborů cookie a vaším výběrem, prosím <a class="cc-link" href="'+contact_url+'">kontaktujte nás</a>.',
                    }
                ]
            }
        }
    }
});
}

window.hmRunCookieConsent = runCookieConsent;
